module.exports = __webpack_public_path__ + "static/media/BALANCE_COLOUR.27b20a79.png";